import { FaGithub } from 'react-icons/fa'
import { MdAlternateEmail } from 'react-icons/md'
import { TiSocialLinkedinCircular } from 'react-icons/ti'
import '../css/Contact.css'

const Contact = ({ contact }) => {
  const { email, github, linkedin } = contact
  return (
    <section className='contact'>
      <div className='iconRow'>
        <a href={github} rel='noreferrer' target='_blank'>
          <FaGithub title='Github profile' size={56} color='#bc13fe' className='iconBtn' />
        </a>
        <a href={`mailto:${email}`}>
          <MdAlternateEmail title='Email' size={75} color='#bc13fe' className='iconBtn' />
        </a>

        <a href={linkedin} rel='noreferrer' target='_blank'>
          <TiSocialLinkedinCircular title='Linkdin profile' size={69} color='#bc13fe' className='iconBtn' />
        </a>
      </div>
    </section>
  )
}

export default Contact
